/**
 * Constante environment
 */
export const environment = {
  production: true,
  bouchon: false
};
